import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from './components/dialog/dialog.component';
import { DialogDirective } from './components/dialog/dialog.directive';
import { MaterialModule } from 'src/shared-app-portal/material.module';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { InjectorModule } from '../app/shared/modules/injector.module';
import { FlexLayoutModule } from 'ngx-flexible-layout';

@NgModule({
  declarations: [DialogComponent, DialogDirective],
  imports: [
    CommonModule,
    MaterialModule,
    NgScrollbarModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    InjectorModule,
    FlexLayoutModule,
  ],
  exports: [
    DialogComponent,
    DialogDirective,
    MaterialModule,
    NgScrollbarModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    InjectorModule,
    FlexLayoutModule,
  ],
})
export class SharedAppPortalModule {}
